// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { FullRescanStepStatusSchema } from '../inputTypeSchemas/FullRescanStepStatusSchema'

/////////////////////////////////////////
// FULL RESCAN STEP SCHEMA
/////////////////////////////////////////

export const FullRescanStepSchema = z.object({
  status: FullRescanStepStatusSchema,
  step: z.string(),
  detail: z.string().nullable(),
})

export type FullRescanStep = z.infer<typeof FullRescanStepSchema>

export default FullRescanStepSchema;
